/**
 * Seedream 5.0 Pro（doubao-seedream-5-0-pro）manifest
 * 数据来源：main 分支画布 configs/seed-5-pro.ts
 * 特点：1K/1.5K/2K 三档清晰度（三档比例选项一致）；参考图上限 10；背景（透明/不透明）
 */
import type { ImageModelConfig, ImageRatioOption } from '../../types';

/** 三档共用的比例选项（接口 field_map 中 1K/1.5K/2K 各自列出但内容一致） */
const RATIOS: ImageRatioOption[] = [
  { label: '1:1', value: '1:1' },
  { label: '2:3', value: '2:3' },
  { label: '3:2', value: '3:2' },
  { label: '3:4', value: '3:4' },
  { label: '4:3', value: '4:3' },
  { label: '9:16', value: '9:16' },
  { label: '16:9', value: '16:9' },
  { label: '21:9', value: '21:9' },
];

export const seed5Pro: ImageModelConfig = {
  id: '01M4Z7A5GFX3MZHFPYKYTYPD7V',
  displayName: 'Seedream5.0 Pro',
  displayNameKey: 'canvas.image.modelNames.seed5Pro',

  // 支持 @ 引用上游图片节点（配置驱动）
  supportAtMention: true,

  defaults: {
    ratio: '9:16', // 接口各档 select: true 项
    resolution: '2K', // 接口 resolution.default
    background: 'opaque', // 默认不透明背景
  },

  ratioOptions: {
    '1K': RATIOS,
    '1.5K': RATIOS,
    '2K': RATIOS,
  },

  resolutionOptions: [
    { label: '标清 1K', labelKey: 'canvas.image.config.level1K', value: '1K' },
    { label: '高清 1.5K', labelKey: 'canvas.image.config.level1_5K', value: '1.5K' },
    { label: '超清 2K', labelKey: 'canvas.image.config.level2KUltra', value: '2K' },
  ],
  resolutionLabel: '图片质量', // 接口 field_map.resolution.label
  resolutionLabelKey: 'canvas.image.config.resolutionTitle',

  qualityOptions: [],

  // 背景：透明/不透明（提交时嵌套 params.background 下发；feed 由 hasBackgroundOption 自动包装）
  backgroundOptions: [
    { label: '透明', labelKey: 'canvas.image.config.bgTransparent', value: 'transparent' },
    { label: '不透明', labelKey: 'canvas.image.config.bgOpaque', value: 'opaque' },
  ],
  // 透明背景要求「仅 1 张带透明通道的参考图」（图生图），feed/画布提交前据此拦截。
  // 仅本模型声明；GPT Image 2.5 系列同样有 transparent 档但不限制参考图数量。
  transparentRequiresSingleRef: true,

  toggles: {},

  limits: {
    maxRefImages: 10, // 接口 field_map.ref_images.max
    // 参考图约束（全部来自接口 field_map.ref_images）
    refImageConstraints: {
      formats: ['jpeg', 'png', 'webp'], // jpg 与 jpeg 互认
      maxFileSizeMB: 30,
      dimension: { min: 15, max: 24000 },
      aspectRatio: { min: 0.0625, max: 16 },
      pixelCount: { min: 196, max: 36000000 },
    },
  },

  /** 画布扩展：提示词上限（feed 无该限制） */
  canvas: {
    limits: { promptMaxLength: 8000 },
  },
};
